import { gql } from "@apollo/client";
import { DeliverySlotsFragment, JobInfoFragment } from "./fragments";

export const JOB_BY_CLIENT_FROM_SUBTASK = gql`
  query jobByClientFromSubtask($input: JobByClientFromSubtaskParams!) {
    jobByClientFromSubtask(params: $input) {
      code
      error
      message
      data {
        ...JobInfo
      }
    }
  }

  ${JobInfoFragment}
`;

export const GET_DELIVERY_SLOTS = gql`
  query getDeliverySlots {
    getDeliverySlots {
      code
      error
      message
      data {
        ...DeliverySlots
      }
    }
  }

  ${DeliverySlotsFragment}
`;
